@app.directive 'trialOrExtendCouponSubscriptionButton', ($state, $location, AnalyticsService) ->
  restrict: 'E'
  scope: {}
  bindToController: {
    label: '='
    buttonUrl: '='
    theme: '='
    alreadySubscribedTitle: '='
    alreadySubscribedText: '='
  }
  controllerAs: 'trialOrExtendCouponSubscriptionButton'

  controller: ($scope, subscriptionService, ModalService, UserAccountService) ->
    @isStudio = $state.currentUser?.studio
    @code = $location.search().premium_code || $location.search().coupon_code
    @showSpinner = false
    @redeemSuccess = false

    @onSubscribeError = (errorMessage) =>
      AnalyticsService.track 'Trial Subscription Button Error', {errorType: errorMessage}
      @error_message = errorMessage
      @showSpinner = false


    @onSuccess = =>
      @takeMeHome()

    @takeMeHome = ->
      window.location = @buttonUrl || "/studiopass"

    @redeem = (code) =>
      if !$state.currentUser
        # ModalService.open('login', source: 'trialRedeem')
        UserAccountService.redirectToAuthPage()
      else
        @showSpinner = true
        subscriptionService.validateCoupon(code)
          .then (_) =>
            if @isStudio
              subscriptionService.redeemAndExtendSubscription(code)
                .then (_) =>
                  @redeemSuccess = true
                .catch (error) =>
                  if error.status == 400
                    @onSubscribeError(error['data']['message'])
                  else
                    @onSubscribeError(error)
            else
              subscriptionService.subscribeTrial(code, @onSubscribeError, @onSuccess)
          .catch (error) =>
            if error.status == 400
              @onSubscribeError(error['data']['message'])
            else
              @onSubscribeError(error)


    $scope.onClick = =>
      if !!@code
        @error_message = null
        @redeem(@code)
      else
        @error_message = 'Please enter a valid code'

    this

  templateUrl: '/assets/templates/components/customButton/trialOrExtendCouponSubscriptionButton/trialOrExtendCouponSubscriptionButton.html'
